import { UZ_MOBILE_CODES } from '@posilka/shared';

/** `901234567` → `90 123 45 67`. */
export const formatUzLocal = (digits: string) =>
  [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 7), digits.slice(7, 9)]
    .filter(Boolean)
    .join(' ');

/**
 * Input matni → `+998` dan keyingi 9 raqam. Operator kodi faqat `UZ_MOBILE_CODES` dan:
 * mos kelmaydigan raqam yozilmaydi (kod qismi to'g'ri prefiksgacha qisqaradi).
 */
export const sanitizeUzLocal = (input: string): string => {
  let digits = input.replace(/\D/g, '');
  // Nusxa qilingan to'liq raqam: 998901234567
  if (digits.length > 9 && digits.startsWith('998')) digits = digits.slice(3);
  digits = digits.slice(0, 9);
  if (digits.length >= 2 && !UZ_MOBILE_CODES.includes(digits.slice(0, 2))) {
    digits = digits.slice(0, 1);
  }
  if (digits.length === 1 && !UZ_MOBILE_CODES.some((c) => c.startsWith(digits))) return '';
  return digits;
};
